import { IMediaResponse } from "@/service/service";
import { createApi } from "@reduxjs/toolkit/query/react";
import { axiosBaseQuery } from "@talentech/components";

export const faviconsApi = createApi({
  reducerPath: "favicons",
  baseQuery: axiosBaseQuery({ baseUrl: process.env.API_URL as string }),
  tagTypes: ["Favicons"],
  endpoints: (builder) => ({
    getFavicons: builder.query<IMediaResponse, Record<string, any>>({
      query: (params) => ({
        url: `/favicon/`,
        params,
      }),
      providesTags: ["Favicons"],
    }),
    deleteFavicon: builder.mutation<void, string>({
      query: (filename) => ({
        url: `/favicon/${filename}`,
        method: "DELETE",
      }),
      invalidatesTags: ["Favicons"],
    }),
  }),
});

export const { useGetFaviconsQuery, useDeleteFaviconMutation } = faviconsApi;
